// extracted by mini-css-extract-plugin
module.exports = {"container":"CentersModale_container__2CjV-","col-2":"CentersModale_col-2__30yW9","check":"CentersModale_check__34z6K"};